
function HTMLRenderer(values, documentId, parentDocumentId) {
  let returnValue = '';

  if (
    values &&
    values['prevod_podielu_custom'] &&
    values['prevod_podielu_custom'][parentDocumentId]
  ) {
    let person = values['prevod_podielu_custom'][parentDocumentId]
      if (person) {
        returnValue = person.percentage
      }
  }
  return returnValue && returnValue !== ''
    ? returnValue
    : undefined;
}

const SharePercent = {
  HTMLRenderer
};

export default SharePercent;
